// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner-loader_spinner__Uo3uz","parent":"spinner-loader_parent__LgQde"};